// eslint-disable-next-line import/no-unresolved
import { MDXProvider } from '@mdx-js/react';
import React from 'react';
import GoogleAdSense from '../components/GoogleAdSense';
import Layout from '../components/Layout';
import SeoHeader from '../components/SeoHeader';
import components from '../utils/remarkable';

function Template({ markdown, renderHeader, renderFrontmatter, wrapMarkdown }) {
  let markdownGuide;

  try {
    markdownGuide = (
      <MDXProvider components={components}>{markdown}</MDXProvider>
    );
  } catch (error) {
    markdownGuide = <code>{error.message}</code>;
  }

  return (
    <>
      {renderHeader !== undefined && renderHeader()}
      {renderFrontmatter !== undefined && renderFrontmatter()}

      {process.env.GATSBY_CA_PUB_ID && (
        <GoogleAdSense
          client={process.env.GATSBY_CA_PUB_ID}
          slot="3008893292"
          format="fluid"
          layout="in-article"
          style={{
            display: 'block',
            minWidth: 250,
            textAlign: 'center',
            marginBottom: 16,
          }}
        />
      )}

      {(wrapMarkdown !== undefined && wrapMarkdown(markdownGuide)) ||
        markdownGuide}

      {process.env.GATSBY_CA_PUB_ID && (
        <GoogleAdSense
          client={process.env.GATSBY_CA_PUB_ID}
          slot="3008893292"
          format="fluid"
          layout="in-article"
          style={{
            display: 'block',
            minWidth: 250,
            textAlign: 'center',
          }}
        />
      )}
    </>
  );
}

function TemplateWrapper({ location, SeoProps, ...rest }) {
  return (
    <Layout location={location}>
      <SeoHeader path={location.pathname} {...SeoProps} />

      <Template {...rest} />
    </Layout>
  );
}

export default TemplateWrapper;
